import { useCallback, useState } from 'react';
import type { ToastMessage, ToastTone } from '../components/ui/Toast';

/** Minimal single-slot toast queue (latest wins). */
export function useToast() {
  const [toast, setToast] = useState<ToastMessage | null>(null);
  const show = useCallback((tone: ToastTone, text: string) => {
    setToast({ id: Date.now(), tone, text });
  }, []);
  const dismiss = useCallback(() => setToast(null), []);
  return { toast, show, dismiss };
}
